/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementEditGroupInfoResponse } from "./GroupManagementEditGroupInfoResponse";

export type GroupManagementEditGroupInfoResponseApiRespoonse = {
  data?: GroupManagementEditGroupInfoResponse;
  status?: GroupManagementEditGroupInfoResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementEditGroupInfoResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
